//TOPページよくある質問アコーディオンパネル(クラス付与クラス削除)
jQuery('.title').on('click', function() {
  jQuery('.box').slideUp(500);
    
  var findElm = jQuery(this).next(".box");
    
  if(jQuery(this).hasClass('close')){
    jQuery(this).removeClass('close');    
  }else{
    jQuery('.close').removeClass('close'); 
    jQuery(this).addClass('close');
    jQuery(findElm).slideDown(500);
  }
});

jQuery(window).on('load', function(){
  jQuery('.accordion-area li:first-of-type section').addClass("open"); 
  jQuery(".open").each(function(index, element){ 
    var Title =jQuery(element).children('.title');
    jQuery(Title).addClass('close'); 
    var Box =jQuery(element).children('.box');
    jQuery(Box).slideDown(500);
  });
});